import { render, staticRenderFns } from "./NotDriverMonthlyUpdateScore.vue?vue&type=template&id=35a63918&"
import script from "./NotDriverMonthlyUpdateScore.vue?vue&type=script&lang=js&"
export * from "./NotDriverMonthlyUpdateScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports